function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("image", {
  id: "Arrows",
  width: 14,
  height: 16,
  xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAYAAAAmlE46AAAAx0lEQVQoke2SrW4CQRSFv5JtEKt5BVx1DQ5FUA2u65rUHVFTSwgO9El4AWpINlRgELgaNI+BRtU0k0zJZrM/CsdRc8/c7/5k5oEoSSmwsT2mJElPwB74tP0VbjuFlEcgrYG+YziV9BYOSTmxAtoCr8ACeAdySd1OEwhMgMz2McZnYAgMGjvanlV4Ac7aOtbqDt4CTCSFv/cB/P6bkp6BUdU7Fkf9AQ5ArwCFYnnjqLZXwBLYAf0Ivdg+te5oew3Mo1cHXa7rAH8VxDdbT0z00QAAAABJRU5ErkJggg=="
});

var SvgArrows = function SvgArrows(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrows, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Arrows.5a045a2f.svg";
export { ForwardRef as ReactComponent };